import React from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Title } from 'bloomer/lib/elements/Title';
import Conditional from './Conditional';
import { Box } from 'bloomer/lib/elements/Box';
import { Level } from 'bloomer/lib/components/Level/Level';
import { LevelLeft } from 'bloomer/lib/components/Level/LevelLeft';
import { LevelItem } from 'bloomer/lib/components/Level/LevelItem';
import ColorBox from '../elements/ColorBox';
import { LevelRight } from 'bloomer/lib/components/Level/LevelRight';
import { Button } from 'bloomer/lib/elements/Button';
import { Icon } from 'bloomer/lib/elements/Icon';

interface Proptypes {
  specialNeeds: SpecialNeed[];
  createHandleDelete: (
    need: SpecialNeed
  ) => (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
  ) => void;
}

const ListSpecialNeeds = ({ specialNeeds, createHandleDelete }: Proptypes) => (
  <Container isFluid={true}>
    <Title tag="h4">Current Special Needs</Title>
    <Conditional check={specialNeeds.length > 0} alt={<p>None.</p>}>
      <>
        {specialNeeds.map(need => {
          const handleDelete = createHandleDelete(need);
          return (
            <Box key={need._id}>
              <Level>
                <LevelLeft>
                  <LevelItem>
                    <ColorBox color={need.color} isSize={'medium'} />
                  </LevelItem>
                  <LevelItem>
                    <p>
                      {need.name} ({need.acronym})
                    </p>
                  </LevelItem>
                </LevelLeft>
                <LevelRight>
                  <LevelItem>
                    <p>Priority: {need.priority}</p>
                  </LevelItem>
                  <Button onClick={handleDelete} isColor="danger">
                    <Icon className="fa fa-trash-o" />
                  </Button>
                </LevelRight>
              </Level>
            </Box>
          );
        })}
      </>
    </Conditional>
  </Container>
);

export default ListSpecialNeeds;
